import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AuthCallback from "./components/AuthCallback";
import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Cashout from "./pages/Cashout";
import PlayEarn from "./pages/PlayEarn";
import Admin from "./pages/Admin";

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#07090E]">
    <div className="flex items-center gap-3 text-cyan-neon">
      <span className="w-3 h-3 rounded-full bg-cyan-400 radar-dot" />
      <span className="font-mono-num text-sm tracking-widest">LOADING…</span>
    </div>
  </div>
);

const Protected = ({ children, adminOnly }) => {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return <Layout>{children}</Layout>;
};

const PublicHome = () => {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (user) return <Navigate to="/dashboard" replace />;
  return <Landing />;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<PublicHome />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/play-earn" element={<Protected><PlayEarn /></Protected>} />
      <Route path="/cashout" element={<Protected><Cashout /></Protected>} />
      <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster
            position="top-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#0C101A",
                border: "1px solid rgba(0,240,255,0.25)",
                color: "#F8FAFC",
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
